import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { useForm, useWatch } from 'react-hook-form';
import { toastConfig } from '../../utils/consts';
import { submitForm } from '../../utils/formApi';
import './style.scss';
import Button from '../Button/Button';

function ContactForm() {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors, isSubmitSuccessful, isSubmitting },
    reset,
  } = useForm({
    mode: 'onTouched',
  });

  const userName = useWatch({
    control,
    name: 'email',
    defaultValue: 'Someone',
  });

  const onSubmit = async (data, e) => {
    setValue('subject', `${userName.split('@')[0]} sent a message using contact form.`);
    setValue('name', userName.split('@')[0]);
    await fetch('/api/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(data, null, 2),
    })
      .then(async (response) => {
        const json = await response.json();
        if (json.success) {
          e.target.reset();
          reset();
          toast.success('Email sent successfuly!', toastConfig);
        } else {
          toast.error('An error has occured, please try again!', toastConfig);
        }
      })
      .catch((error) => {
        toast.error('An error has occured, please try again!', toastConfig);
      });
  };
  return (
    <form
      id='contact_form__footer'
      className='form__container lg:w-[580px]'
      onSubmit={handleSubmit(onSubmit)}
    >
      <span className='form__title'>Contact form</span>
      <p className='p3 form__description mt-4 lg:mb-9 mb-2'>
        We help companies scale their strategies across multiple channels to drive more revenue,
        more quickly, without cutting corners.
      </p>
      <input
        type='hidden'
        value={process.env.FORMS_ACCESS_TOKEN}
        {...register('access_key')}
      />
      <input
        type='hidden'
        {...register('subject')}
      />
      <input
        type='hidden'
        {...register('from_name')}
      />
      <input
        type='email'
        id='email'
        name='email'
        placeholder='Email address*'
        required
        className='lg:mb-6 mb-3 lg:px-5 px-3 placeholder:opacity-40'
        {...register('email', { required: true, pattern: /^\S+@\S+$/i })}
      />
      <textarea
        id='message'
        name='message'
        rows='5'
        placeholder='Message*'
        required
        className='resize-none mb-5 py-3 lg:px-5 px-3 placeholder:opacity-40'
        {...register('message', { required: true })}
      />
      <div className='flex justify-end'>
        <button type='submit'>
          <Button text='Submit' />
        </button>
      </div>
    </form>
  );
}

export default ContactForm;
